module.exports = __webpack_public_path__ + "img/2g.fc3bb8f4.svg";